import { useNotificationServiceNotificationItemsRetrieve } from '@notification/api/queries'
import { useNotificationsSocket } from '@notification/hooks'
import { notification } from 'antd'
import { createContext, useEffect, useState } from 'react'

type NotificationsContextValue = {
  refetchData: boolean
  setRefetchData: (refetch: boolean) => void
}

type Data = {
  notification_id: string
}

type Props = {
  showAlert?: boolean
}

export const NotificationContext = createContext<NotificationsContextValue>({
  refetchData: false,
  setRefetchData: () => null
})

export const NotificationsContextProvider = ({
  showAlert = false,
  children
}: React.PropsWithChildren<Props>) => {
  const [refetchData, setRefetchData] = useState(true)

  const [api, contextHolder] = notification.useNotification()
  const [id, setId] = useState<string>()

  const { data } = useNotificationServiceNotificationItemsRetrieve(
    { id: String(id) },
    undefined,
    {
      enabled: !!id && showAlert
    }
  )

  useEffect(() => {
    if (!data || !showAlert) return

    api.warning({
      message: data?.context?.order?.product?.name,
      key: id
    })

    return () => api.destroy(id)
  }, [api, data, id, showAlert])

  useNotificationsSocket({
    refetchData,
    onMessage: (data) => {
      const notificationData = JSON.parse(data.data) as Data

      setId(notificationData?.notification_id)
    }
  })

  return (
    <NotificationContext.Provider value={{ refetchData, setRefetchData }}>
      {children}
      {contextHolder}
    </NotificationContext.Provider>
  )
}
